import { ChevronRight, Home } from "lucide-react";
import React from "react";
import { useTheme } from "../../../../contexts/ThemeContext";

interface BreadcrumbNavProps {
  currentPath: string;
  onNavigate: (path: string) => void;
}

const BreadcrumbNav: React.FC<BreadcrumbNavProps> = ({
  currentPath,
  onNavigate,
}) => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";

  // Split path into segments
  const segments = currentPath ? currentPath.split("/").filter(Boolean) : [];

  // Build paths for each segment
  const buildPath = (index: number): string => {
    return segments.slice(0, index + 1).join("/");
  };

  return (
    <div className="flex items-center space-x-1 text-sm overflow-x-auto">
      {/* Home/Root button */}
      <button
        onClick={() => onNavigate("")}
        className={`flex items-center space-x-1 px-2 py-1 rounded transition-colors ${
          isDarkMode
            ? "text-rp-grey/70 hover:text-rp-grey hover:bg-rp-surface-raised"
            : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
        } ${segments.length === 0 ? (isDarkMode ? "text-teal-400" : "text-teal-600") : ""}`}
      >
        <Home className="w-4 h-4" />
        <span>Home</span>
      </button>

      {/* Path segments */}
      {segments.map((segment, index) => (
        <React.Fragment key={index}>
          <ChevronRight
            className={`w-4 h-4 flex-shrink-0 ${isDarkMode ? "text-rp-grey/40" : "text-gray-400"}`}
          />
          <button
            onClick={() => onNavigate(buildPath(index))}
            className={`px-2 py-1 rounded transition-colors whitespace-nowrap ${
              index === segments.length - 1
                ? isDarkMode
                  ? "text-teal-400 font-medium"
                  : "text-teal-600 font-medium"
                : isDarkMode
                  ? "text-rp-grey/70 hover:text-rp-grey hover:bg-rp-surface-raised"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            }`}
          >
            {segment}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default BreadcrumbNav;

